<template>
  <div class="my-rankings">
    <rp-sprite class="close-icon" name="close" @click.native="onClose"/>
    <h2>My Rankings</h2>

    <div class="rankings-item border-bottom">
      <div class="title" v-if="data.score"><span>{{data.score}}</span>%</div>
      <div class="title" v-else><span>N/A</span></div>
      <span class="subtitle">RayPRO Score</span>
      <rp-sprite class="share-icon" name="share" @click.native="openSharing('Score', data.score, null)"/>
    </div>

    <div class="rankings-item">
      <div class="title" v-if="data.global"><span>{{data.global.rank}}</span> / {{data.global.count}} Surgeons</div>
      <div class="title" v-else><span>N/A</span></div>
      <span class="subtitle">Global Ranking</span>
      <rp-sprite class="share-icon" name="share" @click.native="openSharing('Global Rank', data.global.rank, data.global.count)"/>
    </div>
    <div class="rankings-item">
      <div class="title" v-if="data.by_country"><span>{{data.by_country.rank}}</span> / {{data.by_country.count}} Surgeons</div>
      <div class="title" v-else><span>N/A</span></div>
      <span class="subtitle">Country Ranking</span>
      <rp-sprite class="share-icon" name="share" @click.native="openSharing('National Rank', data.global.rank, data.global.count)"/>
    </div>
    <div class="rankings-item">
      <div class="title" v-if="data.by_continent"><span>{{data.by_continent.rank}}</span> / {{data.by_continent.count}} Surgeons</div>
      <div class="title" v-else><span>N/A</span></div>
      <span class="subtitle">Continent Ranking</span>
      <rp-sprite class="share-icon" name="share" @click.native="openSharing('Continent Rank', data.global.rank, data.global.count)"/>
    </div>

    <rp-overlay :active="showSharingPanel">
      <rp-social-sharing-form
        @close="showSharingPanel = false"
        :label="sharingLabel"
        :numberValue="sharingNumberValue"
        :numberFrom="sharingNumberFrom" />
    </rp-overlay>
  </div>
</template>

<script>
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import RpLogo from 'raypro_ui/src/components/ui/Logo'
import Sprite from 'raypro_ui/src/components/ui/Sprite'

import SocialSharingForm from 'raypro_ui/src/components/ui/forms/SocialSharing'

export default {
  props: {
    onClose: {
      type: Function,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showSharingPanel: false,
      sharingNumberValue: 0,
      sharingNumberFrom: 0,
      sharingLabel: ''
    }
  },
  components: {
    RpLogo,
    'rp-social-sharing-form': SocialSharingForm,
    'rp-overlay': Overlay,
    'rp-sprite': Sprite
  },
  methods: {
    openSharing(label, numberValue, numberFrom) {
      this.showSharingPanel = true
      this.sharingLabel = label
      this.sharingNumberValue = numberValue
      this.sharingNumberFrom = numberFrom
    }
  }
}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'

  .rankings-item, .ranking

  .my-rankings
    position: fixed
    top: 75px
    right: 0
    bottom: 0
    padding: 5rem 30px
    width: 340px
    height: 100vh
    color: $color-text
    background-color: $color-panel-bg
    border-top: 1px solid $color-grey-lighter
    z-index: 10
    -webkit-box-shadow: -5px 0px 10px -6px rgba(0,0,0,0.23)
    -moz-box-shadow: -5px 0px 10px -6px rgba(0,0,0,0.23)
    box-shadow: -5px 0px 10px -6px rgba(0,0,0,0.23)

    .close-icon
      cursor: pointer
      position: absolute
      top: 49px
      right: 40px
      width: 20px
      height: 20px

    .share-icon
      cursor: pointer
      width: 24px
      height: 24px
      fill: #5B6C72
      position: absolute
      right: 0
      top: 0
      bottom: 0
      margin: auto
      padding: 2px

    h2
      margin: 0 0 30px
      font-size: 1.5rem
      font-weight: $font-medium
      text-align: center
      text-transform: uppercase

    .rankings-item
      position: relative
      padding: 20px 0
      background-color: $color-panel-bg

      &.border-bottom
        padding: 30px 0
        border-bottom: 1px solid $color-grey-lighter

      &:last-of-type
        border-bottom: none

      .title
        font-size: 18px
        margin-bottom: 10px
        font-weight: $font-light

        > span
          font-size: 52px
          font-weight: $font-regular
          font-family: $app-font-slab

      .subtitle
        font-size: 12px
</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard/MyRankings.vue